
import React from 'react';
import { cn } from '@/lib/utils';

export interface SidebarMenuItemProps extends React.LiHTMLAttributes<HTMLLIElement> {}

export const SidebarMenuItem = React.forwardRef<HTMLLIElement, SidebarMenuItemProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <li
        ref={ref}
        className={cn('', className)} // No default item styling, handled by button
        {...props}
      >
        {children}
      </li>
    );
  }
);
SidebarMenuItem.displayName = 'SidebarMenuItem';
